import React, { useEffect, useRef, useState } from 'react'
import CardElement from '../../components/card.v2'
import { useFormikContext } from 'formik'
import { LayoutWithAvatar } from '../gender/gender'
import { Play, Pause } from 'lucide-react'
import { useAvatar } from '../avatar/avatar.context'
import { HoverBorderGradientDemo } from '../../components/Button'
import env from '../../config/configuration'

const voices = [
  {
    name: 'Sarah',
    gender: 'female',
    preview:
      'https://storage.googleapis.com/eleven-public-prod/premade/voices/EXAVITQu4vr4xnSDxMaL/01a3e33c-6e99-4ee7-8543-ff2216a32186.mp3',
    voiceId: '2ea9759b1e1f42b2b852e7a2a40ce4d0',
  },
  {
    name: 'Laura',
    gender: 'female',
    preview:
      'https://storage.googleapis.com/eleven-public-prod/premade/voices/FGY2WhTYpPnrIDTdsKH5/67341759-ad08-41a5-be6e-de12fe448618.mp3',
    voiceId: 'f97c4c92cf3947bb8eda09507a6f7da0',
  },
  {
    name: 'Charlie',
    gender: 'male',
    preview:
      'https://storage.googleapis.com/eleven-public-prod/premade/voices/IKne3meq5aSn9XLyUdCD/102de6f2-22ed-43e0-a1f1-111fa75c5481.mp3',
    voiceId: '946e31ad8cdd4f13a3c9e5576ca429c7',
  },
  {
    name: 'Alice',
    gender: 'female',
    preview:
      'https://storage.googleapis.com/eleven-public-prod/premade/voices/Xb7hH8MSUJpSbSDYk0k2/d10f7534-11f6-41fe-a012-2de1e482d336.mp3',
    voiceId: '6b622116cec9459da5db71b5bdc9446d',
  },
  {
    name: 'Matilda',
    gender: 'female',
    preview:
      'https://storage.googleapis.com/eleven-public-prod/premade/voices/XrExE9yKIg1WjnnlVkGX/b930e18d-6b4d-466e-bab2-0ae97c6d8535.mp3',
    voiceId: '9c341a4a8a2344c695731fc07c3a7b1c',
  },
  {
    name: 'Jessica',
    gender: 'female',
    preview:
      'https://storage.googleapis.com/eleven-public-prod/premade/voices/cgSgspJ2msm6clMCkdW9/56a97bf8-b69b-448f-846c-c3a11683d45a.mp3',
    voiceId: '1e7aef7c71264d1a8f1a2f1db73b643b',
  },
  {
    name: 'Eric',
    gender: 'male',
    preview:
      'https://storage.googleapis.com/eleven-public-prod/premade/voices/cjVigY5qzO86Huf0OWal/d098fda0-6456-4030-b3d8-63aa048c9070.mp3',
    voiceId: '997a37190cf84e17b158f5a8333b935a',
  },
  {
    name: 'Daniel',
    gender: 'male',
    preview:
      'https://storage.googleapis.com/eleven-public-prod/premade/voices/onwK4e9ZLuTAKqWW03F9/7eee0236-1a72-4b86-b303-5dcadc007ba9.mp3',
    voiceId: 'd1fb921dbab0466ea539fcf01979cd35',
  },
  {
    name: 'Lily',
    gender: 'female',
    preview:
      'https://storage.googleapis.com/eleven-public-prod/premade/voices/pFZP5JQG7iQjIQuC4Bku/89b68b35-b3dd-4348-a84a-a3c13a3c2b30.mp3',
    voiceId: '3b0c4bec91034982961616f770550eb3',
  },
  {
    name: 'George',
    gender: 'male',
    voiceId: '420aad91135a446d89e25ff29ea49eb6',
    preview:
      'https://storage.googleapis.com/eleven-public-prod/premade/voices/JBFqnCBsd6RMkjVDRZzb/e6206d1a-0721-4787-aafb-06a6e705cac5.mp3',
  },
  {
    name: 'Chris',
    gender: 'male',
    voiceId: 'b7733982992545e5bff20cbd54b0e81b',
    preview:
      'https://storage.googleapis.com/eleven-public-prod/premade/voices/iP95p4xoKVk53GoZ742B/3f4bde72-cc48-40dd-829f-57fbf906f4d7.mp3',
  },
  {
    name: 'Bill',
    gender: 'male',
    voiceId: 'b5c1ee2cdce3455db51662de3bd414dd',
    preview:
      'https://storage.googleapis.com/eleven-public-prod/premade/voices/pqHfZKP75CvOlQylNhV4/d782b3ff-84ba-4029-848c-acf01285524d.mp3',
  },
]

const AvatarProfile = ({ onSelect, ...voice }) => {
  const { values } = useFormikContext()
  const [isPlaying, setIsPlaying] = useState(false)
  const audioRef = useRef(new Audio(voice.preview))

  const togglePlayPause = () => {
    if (isPlaying) {
      audioRef.current.pause()
    } else {
      audioRef.current.play()
    }
    setIsPlaying(!isPlaying)
  }

  // Reset state when the audio ends
  audioRef.current.onended = () => setIsPlaying(false)

  return (
    <div className='flex justify-center items-center flex-col'>
      <div
        onClick={() => onSelect(voice.voiceId)}
        className={`border-4 flex items-center justify-center w-16 h-16 rounded-full bg-gray-800 hover:bg-gray-700 text-white shadow-lg transition ${
          values.voiceId == voice.voiceId
            ? 'border-blue-500'
            : 'border-gray-300'
        } overflow-hidden`}
      >
        {voice.preview ? (
          <button onClick={togglePlayPause}>
            {isPlaying ? (
              <Pause className='w-8 h-8' />
            ) : (
              <Play className='w-8 h-8' />
            )}
          </button>
        ) : (
          ''
        )}
      </div>

      <div className='flex items-center justify-center gap-2 mt-2 w-full'>
        <p className='text-sm font-semibold truncate' title={voice.name}>
          {voice.name}
        </p>
      </div>
    </div>
  )
}

const Traits = ({ currentStep, setCurrentStep }) => {
  const { values, setFieldValue } = useFormikContext()
  const [modalPosition, setModalPosition] = useState(null)
  const [showModal, setShowModal] = useState(false)
  const [filteredVoices, setFilteredVoices] = useState([])
  const [loadingVoices, setLoadingVoices] = useState(false)
  const { processing } = useAvatar()
  const agent = JSON.parse(localStorage.getItem('agent'))

  const personalityFilters = {
    Outgoing: [
      'confident',
      'friendly',
      'casual',
      'natural',
      'expressive',
      'wise',
      '',
    ],
    Empathetic: [
      'soft',
      'trustwothy',
      'friendly',
      'expressive',
      'natural',
      'warm',
      '',
    ],
    Sassy: ['expressive', 'confident', 'authoritative', 'articulate', ''],
    'Southern Charm': ['charming', 'friendly', 'upbeat', 'soft', ''],
  }

  const filterByGender = (voice) =>
    voice.gender.toLowerCase() == values.gender.toLowerCase()
  const filterByLanguage = (voice) => voice.language == 'English'
  const filterBySupport = (voice) => voice.support_interactive_avatar

  // const filterByTraits = (voice) =>
  //   personalityFilters[values.traits].includes(voice.labels.description)

  const getPlayHTVoices = async () => {
    const result = await fetch('https://api.play.ht/api/v2/voices', {
      method: 'GET',
      headers: {
        AUTHORIZATION: env.PLAYAI_SECRETKEY,
        'X-USER-ID': env.PLAYAI_USERID,
      },
    })

    const { voices } = await result.json()
    console.log(voices)
  }

  const getELVoices = async () => {
    const result = await fetch('https://api.elevenlabs.io/v1/voices', {
      method: 'GET',
      headers: { 'x-api-key': env.ELEVEN_LAB_API },
    })

    const { voices } = await result.json()
    return voices.map((voice) => ({
      name: voice.name,
      voiceId: '11labs-' + voice.name,
      preview: voice.preview_url,
      gender: voice.labels.gender,
    }))
  }

  const getVoices = async () => {
    const result = await fetch('https://api.retellai.com/list-voices', {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${env.RETELL_API}`,
      },
    })

    const voices = await result.json()
    return voices.map((voice) => ({
      name: voice.voice_name,
      voiceId: voice.voice_id,
      preview: voice.preview_audio_url,
      gender: voice.gender,
    }))
  }

  const getAvatarVoiceList = async () => {
    setLoadingVoices(true)
    if (agent.method == 'Web' || agent.method == 'Phone') {
      const voices = await getVoices()
      const filteredVoices = voices.filter((voice) => {
        return filterByGender(voice) //&&
        // filterByTraits(voice)
        // filterByLanguage(voice) &&
        // filterBySupport(voice)
      })
      setFilteredVoices(filteredVoices || [])
    } else {
      const filteredVoices = voices.filter((voice) => {
        return filterByGender(voice) //&&
        // filterByTraits(voice)
        // filterByLanguage(voice) &&
        // filterBySupport(voice)
      })
      setFilteredVoices(filteredVoices || [])
    }

    setLoadingVoices(false)
  }

  const handleSelectedVoice = (voiceId) => {
    setFieldValue(`voiceId`, voiceId)
    setShowModal(false)
  }

  useEffect(() => {
    getAvatarVoiceList()
  }, [])

  return (
    <LayoutWithAvatar>
      {/* Left Section */}
      <div className='col-span-2 md:col-span-1 max-w-sm mx-auto flex items-center gap-20 justify-center'>
        <div className='relative'>
          <CardElement fixHeight>
            <h2 className='text-gray-700 font-semibold mb-4 cursor-pointer'>
              <svg
                onClick={() => {
                  setCurrentStep(currentStep - 1)
                }}
                xmlns='http://www.w3.org/2000/svg'
                fill='none'
                viewBox='0 0 24 24'
                strokeWidth='2'
                stroke='currentColor'
                className='w-5 h-5'
              >
                <path
                  strokeLinecap='round'
                  strokeLinejoin='round'
                  d='M15 19l-7-7 7-7'
                />
              </svg>
            </h2>
            <h2 className='text-gray-700 font-semibold mb-4 text-lg'>
              Select Best Voice Suitable For Your Brand:
            </h2>

            {processing ? (
              <div>Loading voice, please wait...</div>
            ) : (
              <div className='grid grid-cols-3 gap-4 max-h-[170px] overflow-auto custom-scrollbar -mx-6 px-6'>
                {filteredVoices.map((voice) => (
                  <AvatarProfile onSelect={handleSelectedVoice} {...voice} />
                ))}
              </div>
            )}

            {/* Button */}
            <div className='mt-8'>
              <HoverBorderGradientDemo
                type='button'
                onClick={() => {
                  setCurrentStep(currentStep + 1)
                }}
                disabled={!values?.gender}
              >
                <span className='font-bold capitalize'>Select</span>
              </HoverBorderGradientDemo>
            </div>
          </CardElement>
          {showModal && (
            <div style={{ ...modalPosition }} className='absolute left-[104%]'>
              <CardElement className={'w-80'}>
                {processing ? (
                  <div>Loading voice, please wait...</div>
                ) : (
                  <div className='grid grid-cols-3 gap-4 max-h-60 overflow-auto custom-scrollbar -mx-6 px-6'>
                    {filteredVoices.map((voice) => (
                      <AvatarProfile
                        onSelect={handleSelectedVoice}
                        {...voice}
                      />
                    ))}
                  </div>
                )}
              </CardElement>
            </div>
          )}
        </div>
      </div>
      {/* Right Section */}
      <div className='col-span-1 hidden md:flex items-center justify-center relative'>
        <div>
          <video
            src={`/videos/3rd-female.webm`}
            style={{
              filter: values.gender == 'Female' ? '' : 'hue-rotate(270deg)',
            }}
            autoPlay
            loop
            className='w-full h-full'
          />
        </div>
      </div>
    </LayoutWithAvatar>
  )
}

export default Traits
